import React from 'react';

const ImprintDe = () => {
  return (
    <div
      style={{
        padding: '48px',
        lineHeight: '1.6',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      <h1>Impressum</h1>

      <section>
        <h2>Angaben gemäß § 5 TMG (Telemediengesetz)</h2>
        <p>
          <strong>Verantwortlich für den Inhalt dieser Website:</strong>
          <br />
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Adresse: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth,
          Israel
          <br />
          E-Mail: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website:{' '}
          <a
            href="https://fotogram.technology"
            target="_blank"
            rel="noopener noreferrer"
          >
            fotogram.technology
          </a>
        </p>

        <p>
          <strong>Handelsregister:</strong>
          <br />
          Fotogram Technology ist kein eingetragenes Unternehmen in Deutschland,
          sondern ein Produkt, das von Eilon Mario Netzer, einer zertifizierten
          Organisation mit Sitz in Israel, betrieben wird.
        </p>

        <p>
          <strong>Vertretungsberechtigter Geschäftsführer:</strong>
          <br />
          Eilon Mario Netzer (CEO)
        </p>

        <p>
          <strong>Hosting:</strong>
          <br />
          Die Website und alle Daten werden auf Servern in Deutschland gehostet,
          die den höchsten Sicherheitsstandards und den Anforderungen der DSGVO
          entsprechen.
        </p>

        <p>
          <strong>
            Umsatzsteuer-Identifikationsnummer gemäß § 27a Umsatzsteuergesetz
            (UStG):
          </strong>
          <br />
          Da Fotogram Technology seinen Sitz in Israel hat, unterliegt das
          Produkt nicht der Umsatzsteuerpflicht in Deutschland. Eine
          Umsatzsteuer-Identifikationsnummer ist daher nicht erforderlich.
        </p>
      </section>

      <section>
        <h2>Haftungsausschluss (Disclaimer)</h2>

        <h3>1. Inhalt des Onlineangebots</h3>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt.
          Dennoch übernehmen wir keine Haftung für die Vollständigkeit,
          Richtigkeit oder Aktualität der bereitgestellten Inhalte. Gemäß § 7
          Abs. 1 TMG sind wir als Dienstanbieter für eigene Inhalte auf diesen
          Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10
          TMG sind wir jedoch nicht verpflichtet, übermittelte oder gespeicherte
          fremde Informationen ständig zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
          Eine Haftung tritt jedoch erst ab dem Zeitpunkt ein, an dem wir von
          einer konkreten Rechtsverletzung Kenntnis erhalten. Sobald uns solche
          Rechtsverletzungen bekannt werden, entfernen wir die entsprechenden
          Inhalte umgehend.
        </p>

        <h3>2. Haftung für Links</h3>
        <p>
          Unsere Website enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb übernehmen wir keine
          Haftung für diese fremden Inhalte. Für die Inhalte der verlinkten
          Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.
          Zum Zeitpunkt der Linksetzung wurden die verlinkten Seiten auf
          mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zu
          diesem Zeitpunkt nicht erkennbar. Eine kontinuierliche Überprüfung der
          Inhalte verlinkter Seiten ist jedoch ohne konkrete Anhaltspunkte einer
          Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
          Rechtsverletzungen entfernen wir derartige Links umgehend.
        </p>

        <h3>3. Urheberrecht</h3>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf dieser
          Website unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
          Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
          Grenzen des Urheberrechts bedürfen der vorherigen schriftlichen
          Zustimmung des jeweiligen Autors oder Erstellers. Downloads und Kopien
          dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
          gestattet. Inhalte Dritter werden als solche gekennzeichnet. Sollten
          Sie dennoch auf eine Urheberrechtsverletzung aufmerksam werden, bitten
          wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
          Rechtsverletzungen entfernen wir derartige Inhalte umgehend.
        </p>
      </section>

      <section>
        <h2>Kontaktinformationen</h2>
        <p>
          Fotogram Technology
          <br />
          CEO: Eilon Mario Netzer
          <br />
          Adresse: 1004 Street Building 18, PO Box 50255, 1616102 Nazareth,
          Israel
          <br />
          E-Mail: <a href="mailto:info@fotogram.app">info[at]fotogram.app</a>
          <br />
          Website:{' '}
          <a
            href="https://fotogram.technology"
            target="_blank"
            rel="noopener noreferrer"
          >
            fotogram.technology
          </a>
        </p>
      </section>

      <section>
        <h2>Verbraucherstreitbeilegung</h2>
        <p>
          Fotogram Technology nimmt nicht an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teil und ist dazu auch nicht
          verpflichtet.
        </p>
      </section>
    </div>
  );
};

export default ImprintDe;
